<template>
    <!-- 公共提示框 -->
    <div class="common-mask" v-if="isShow">
        <div class="mask-box">
            <div class="btn-close" @click="closeMask()">
                <img src="../assets/images/close_icon.png" />
            </div>
            <!-- {{tipMsg}} -->
            <p class="mask-notice">
                {{ $t("commonModal.msg", { msg: tipMsg }) }}
            </p>
            <div
                class="mask-btn-group custom-justify-content-around"
                v-if="isBtnGroup"
            >
                <button
                    type="button"
                    class="common-comfirm-btn common-prev-btn"
                    @click="cancel()"
                >
                    {{ $t("commonModal.btnNo") }}
                </button>
                <button
                    type="button"
                    class="common-comfirm-btn"
                    @click="confirm()"
                    v-if="!canLink"
                >
                    {{ $t("commonModal.btnYes") }}
                </button>
                <button
                    type="button"
                    class="common-comfirm-btn"
                    @click="confirm()"
                    v-if="canLink"
                >
                    <a :href="linkUrl" target="_blank" class="out-link-confirm">
                        {{ $t("commonModal.btnYes") }}
                    </a>
                </button>
            </div>
            <div
                class="mask-btn-group custom-justify-content-center"
                v-if="!isBtnGroup"
            >
                <button
                    type="button"
                    class="common-comfirm-btn"
                    @click="confirm()"
                >
                    {{ $t("commonModal.btnRewrite") }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CommonModal',
    props: {
        isShow: {
            type: Boolean
        },
        canLink: {
            type: Boolean
        },
        tipMsg: {
            type: String
        },
        isBtnGroup: {
            type: Boolean
        },
        linkUrl: {
            type: String
        }
    },
    methods: {
        // 关闭按钮
        closeMask() {
            this.$emit("closeEvent");
        },
        // 取消按钮事件
        cancel() {
            this.$emit("cancelEvent");
        },
        // 确定按钮事件
        confirm() {
            this.$emit("confirmEvent");
        }
    }
};
</script>

<style lang="scss" scoped>
.common-mask {
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    background: rgba($color: #000000, $alpha: 0.59);
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    overflow: hidden;
}

.mask-box {
    position: relative;
    z-index: 1001;
    text-align: center;
    padding: 70px 90px 60px 90px;
    width: 560px;
    height: 290px;
    background: rgba($color: #000000, $alpha: 1);
}

.btn-close {
    position: absolute;
    z-index: 1002;
    cursor: pointer;
    right: -20px;
    top: -20px;
}

.btn-close img {
    width: 40px;
    height: 40px;
}

.mask-box .mask-notice {
    color: #fff;
    font-size: 28px;
}

.mask-btn-group {
    display: flex;
    margin-top: 35px;
}

.custom-justify-content-around {
    justify-content: space-around;
}

.custom-justify-content-center {
    justify-content: center;
}

.mask-btn-group button {
    width: 140px;
}

.out-link-confirm{
    display: block;
    width: 100%;
    height: 100%;
    color: #fff;
}

.custom-justify-content-around button:first-child {
    background: rgba($color: #fff, $alpha: 0.3);
}

/*适配手机*/

@media only screen and (min-width: 320px) and (max-width: 767px) {
    .mask-box {
        padding: 30px 45px;
        width: 280px;
        height: 145px;
    }
    .btn-close {
        right: -10px;
        top: -10px;
    }
    .btn-close img {
        width: 20px;
        height: 20px;
    }
    .mask-box .mask-notice {
        font-size: 16px;
    }
    .mask-btn-group {
        margin-top: 20px;
    }
    .mask-btn-group button {
        width: 90px;
        height: 26px;
        line-height: 26px;
    }
}
</style>